// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2TIMN","title":"FrontImage_title__3JZFs"};